import { useSyncExternalStore } from "react";

const isBrowser = typeof window !== "undefined" && typeof navigator !== "undefined";

// Read the current status rather than caching it, so the first paint after a
// reconnect is never stale.
const getSnapshot = (): boolean => (isBrowser ? navigator.onLine : true);

const subscribe = (callback: () => void): (() => void) => {
  if (!isBrowser) return () => {};

  window.addEventListener("online", callback);
  window.addEventListener("offline", callback);
  return () => {
    window.removeEventListener("online", callback);
    window.removeEventListener("offline", callback);
  };
};

/**
 * Tracks browser connectivity via the `online`/`offline` events.
 *
 * Used to keep the installed PWA presentable offline: the learn shell is
 * precached, but /svc data is deliberately never cached, so consumers use this
 * to show offline-aware states and to mark uncached sibling apps
 * (champions, ka) as unavailable rather than dead-ending in the browser error
 * page.
 */
export function useOnlineStatus(): boolean {
  // This app is client-rendered - getServerSnapshot here
  // covers non-browser contexts like Storybook/test runners
  return useSyncExternalStore(subscribe, getSnapshot, () => true);
}
